import { auth } from "../firebase";
import { getApiBase } from "./apiBase";

/**
 * Push one library admin to Zoho CRM (server enforces: super admin any uid, or self uid + admin).
 * @param {string} uid Firestore user id
 * @returns {Promise<object>} Parsed JSON body from POST /api/zoho/sync-admin
 */
export async function pushLibraryAdminToZoho(uid) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("Not signed in; cannot sync to Zoho CRM.");
  }
  if (!uid) {
    throw new Error("Missing user id for Zoho CRM sync.");
  }
  const idToken = await user.getIdToken();
  const res = await fetch(`${getApiBase()}/api/zoho/sync-admin`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ uid }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Zoho sync failed (${res.status})`);
  }
  return data;
}
